"use strict";

module.exports = fastTwoSum;

function fastTwoSum(a, b, result) {
  var x = a + b;
  var bv = x - a;
  var av = x - bv;
  var br = b - bv;
  var ar = a - av;

  if (result) {
    result[0] = ar + br;
    result[1] = x;
    return result;
  }

  return [ar + br, x];
}